export const lightTheme = {
  mode: 'light',
  text: 'var(--gray900, #181818)',
  subText: 'var(--gray500, #555)',
  bgColor: 'var(--white, #fff)',
  inputBgColor: 'var(--white, #fff)',
  landingCard: 'var(--surface, #f6f8ff)',
  borderBottom: '#ededed',

  btnBorderColor: '#f6f6f6',
  btnBgColor: '#f6f6f6',
  buttonColor: 'var(--white , #fff)',
  buttonSelectText: '#861dee',
  buttonSelectColor: 'var(--white, #fff)',
};

export const darkTheme = {
  mode: 'dark',
  text: '#e0e0e0',
  subText: '#999',
  bgColor: '#131418',
  inputBgColor: 'var(--black, #000)',
  landingCard: '#1f2023',
  borderBottom: '#24262b',

  btnBorderColor: '#24262b',
  btnBgColor: '#191a1e',
  buttonColor: '#191a1e',
  buttonSelectText: '#861dee',
  buttonSelectColor: '#363840',
};
